import events from '../events';
import usersApiClient from '../login-register/UsersApiClient';
export function BottomMenu() {
    return {
        title: '',
        links: [],
        selectedItem: null,
        open: false,
        mainLink: null,
        init() {
            events.onBottomMenuShow.subscribe(item => this.showMenu(item));
        },
        showMenu(item) {
            if (item.title === this.title) {
                return this.close();
            }
            document.body.style.overflow = 'hidden';
            this.open = true;
            this.title = item.title;
            this.mainLink = item.mainLink != undefined ? item.mainLink : "#";
            this.links = item.links.map(link => {
                var _a;
                link.action = undefined;
                if (link.url.startsWith('action:')) {
                    const functionName = link.url.split(':')[1];
                    // @ts-ignore
                    if (!this[functionName]) {
                        throw `Function '${functionName}' not found`;
                    }
                    // @ts-ignore
                    link.action = this[functionName];
                }
                var foundCategories = item.categories != undefined
                    ? item.categories.find(x => x.title === link.name)
                    : null;
                link.subCategories =
                    foundCategories != null
                        ? (_a = foundCategories.subcategories) !== null && _a !== void 0 ? _a : []
                        : [];
                return link;
            });
        },
        selectItem(item) {
            this.selectedItem = item;
        },
        close() {
            document.body.style.overflow = '';
            this.title = '';
            this.links = [];
            this.open = false;
        },
        logout() {
            usersApiClient.logout()
                .then(() => location.reload());
        }
    };
}
export function BottomMenuItem(item) {
    return {
        item,
        openMenu() {
            events.onBottomMenuShow.trigger(this.item);
        },
    };
}
